const STORAGE_KEY = 'favouriteScripts';

export const loadFavourites = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    const parsed = saved ? JSON.parse(saved) : [];
    return new Set(Array.isArray(parsed) ? parsed.map(String) : []);
  } catch (error) {
    return new Set();
  }
};

export const saveFavourites = (favourites) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...favourites]));
};

export const toggleFavouriteId = (instrumentIdentifier) => {
  const id = String(instrumentIdentifier ?? '');
  if (!id) return loadFavourites();
  const next = loadFavourites();
  if (next.has(id)) next.delete(id);
  else next.add(id);
  saveFavourites(next);
  window.dispatchEvent(new CustomEvent('favouritesUpdated'));
  return next;
};
